import parser from "html-react-parser";
import xss from "xss";

export default function parseHtmlToJsx(content: string = "") {
  return parser(
    xss(content, {
      whiteList: {
        a: ["href", "title", "target", "class"],
        b: [],
      },
    })
  );
}
